import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import style from './index.css';
import PropTypes from 'prop-types';

const Banner = ({ title }) => {
  return (
    <div className={style.yesterday}>{title}</div>
  );
};

Banner.propTypes = {
  title: PropTypes.string
};

export default errorBoundary(Banner);
